/**
 * 数字千分制格式化工具函数
 */
import { t } from '../i18n';

/**
 * 将数字格式化为千分制显示
 * @param value 要格式化的数字
 * @param decimals 小数位数，如果指定则强制显示指定位数，否则自动舍弃末尾的0
 * @returns 格式化后的字符串
 */
export const formatNumberWithCommas = (value: number | null | undefined, decimals?: number): string => {
    if (value === null || value === undefined) {
        return '-';
    }
    
    let formattedNumber: string;
    
    if (decimals !== undefined) {
        // 如果指定了小数位数，强制显示指定位数（不足补0）
        formattedNumber = Number(value).toFixed(decimals);
    } else {
        // 如果没有指定小数位数，使用原始数字的精度，然后去除末尾的0
        formattedNumber = Number(value).toString();
        // 去除小数点后末尾的0
        formattedNumber = formattedNumber.replace(/\.0+$/, '');
    }
    
    // 分离整数部分和小数部分
    const parts = formattedNumber.split('.');
    const integerPart = parts[0];
    const decimalPart = parts[1];
    
    // 对整数部分添加千分位分隔符
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    
    // 如果有小数部分，则拼接回去
    return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger;
};

/**
 * 将重量从公斤转换为磅并格式化显示
 * @param weightKg 公斤重量
 * @returns 格式化后的磅重量字符串，保留两位小数
 */
export const formatWeightKgToLb = (weightKg: number | null | undefined): string => {
    if (!weightKg) return '-';
    const weightLb = weightKg * 2.20462;
    return `${weightLb.toFixed(2)} ${t('components.timeline.lb')}`;
};

/**
 * 将长度从厘米转换为英寸并格式化显示
 * @param lengthCm 厘米长度
 * @returns 格式化后的英寸长度字符串，保留两位小数
 */
export const formatLengthCmToInch = (lengthCm: number | null | undefined): string => {
    if (!lengthCm) return '';
    const lengthInch = lengthCm / 2.54;
    return lengthInch.toFixed(2);
};